import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/state/AppContext";
import { api, apiErrorMessage } from "@/lib/api";

/** The ONE account-deletion action, shared by the public `/delete-account` page and the Account
 * page's "Delete my account". `POST /auth/account/delete` already refuses partner accounts and
 * tombstones the identity; every existing token is dead server-side, `signOut` clears the local
 * session so the UI does not keep showing one. */
export function useAccountDeletion() {
  const { signOut, t } = useApp();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    setBusy(true);
    try {
      await api.post("/auth/account/delete");
      signOut();
      toast.success(t("account.deleted"));
      navigate("/");
      return true;
    } catch (e) {
      toast.error(apiErrorMessage(e, t("account.deleteFailed")));
      return false;
    } finally {
      setBusy(false);
    }
  };

  return { remove, busy };
}
